import SliderClientsList from './slider-clients.json';
export interface SliderClient {
  name: string;
  className: string;
}
export const SliderClients: SliderClient[] = SliderClientsList;
